import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ApiResponseObject } from '../models/responses/api-response-object';
import { Injectable } from '@angular/core';
import { DepartmentDto } from '../models/DepartmentDto';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {

  constructor(private httpClient: HttpClient) { }
  getDepartments(): Observable<ApiResponseObject<DepartmentDto[]>> {
    return this.httpClient.get<ApiResponseObject<DepartmentDto[]>>(`${environment.apiUrl}/Departments`);
  }
  
  saveDepartment(newContractRequest: DepartmentDto): Observable<ApiResponseObject<DepartmentDto>> {
   
    return this.httpClient.post<ApiResponseObject<DepartmentDto>>(`${environment.apiUrl}/Departments`, newContractRequest);
  }
}
